import React from "react";
import { Link } from "react-router-dom";
import { pageTitle } from "../../config/page-settings";

class SidebarProfile extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      profileActive: 0,
    };
    this.handleProfileExpand = this.handleProfileExpand.bind(this);
  }

  handleProfileExpand (e) {
    e.preventDefault();
    this.setState(state => ({
      profileActive: !this.state.profileActive,
    }));
  }

  render () {
    return (
      <ul className="nav">
        <li className={"nav-profile " + (this.state.profileActive ? "expand " : "")}>
          <Link to="/" onClick={() => console.log}>
            <div className="cover with-shadow"></div>
            <div className="image">
              {/* <img src="/assets/img/user/user-13.jpg" alt="" /> */}
            </div>
            <div className="info">
              {/* <b className="caret pull-right">123</b> */}
              <b>{pageTitle}</b>
              <small>{pageTitle}的工作小站</small>
            </div>
          </Link>
        </li>
        <li>
          <ul className={"nav nav-profile " + (this.state.profileActive ? "d-block " : "")}>
            <li><Link to="/"><i className="fa fa-cog"></i> Settings</Link></li>
            <li><Link to="/"><i className="fa fa-pencil-alt"></i> Send Feedback</Link></li>
            <li><Link to="/"><i className="fa fa-question-circle"></i> Helps</Link></li>
          </ul>
        </li>
      </ul>
    );
  }
}

export default SidebarProfile;
